<template>
  <div id="svg-icon" :class="'is-txt-'+color">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9945 44.0774C25.437
    44.0762 26.7901 43.6933 27.9583 43.0242L28.0083 43.0741L28.2055
    42.8766C30.4781 41.4639 31.9903 38.9436 31.9879 36.0708C31.9858 33.5212
    30.7912 31.2511 28.9321 29.7877C28.9653 29.5544 28.9824 29.3158 28.9822
    29.0733L28.9658 9.0733C28.9635 6.31188 26.7231 4.07513 23.9617
    4.07739C21.2003 4.07966 18.9635 6.32007 18.9658 9.08149L18.9822
    29.0815C18.9824 29.324 18.9998 29.5625 19.0334 29.7958C17.1767 31.2623
    15.9858 33.5343 15.9879 36.0839C15.9915 40.5022 19.5762 44.081 23.9945
    44.0774ZM20.2789 31.3607L20.273 31.3653C20.0575 31.5356 19.854 31.7201
    19.664 31.9174L28.1549 40.3944C28.3539 40.2022 28.5397 39.9965 28.7107
    39.7786L20.2789 31.3607ZM18.208 34.4605C18.2906 34.1644 18.3953 33.8775
    18.5204 33.6018L26.4722 41.5405C26.1967 41.666 25.91 41.7713 25.614
    41.8544L18.208 34.4605ZM18.0863 37.1651C18.5341 39.6103 20.4639 41.537
    22.9099 41.9808L18.0863 37.1651ZM20.9865 29.241L29.6948 37.935C29.7942
    37.6295 29.8697 37.3132 29.9192 36.9884L20.9814 28.0652L20.9822
    29.0798C20.9822 29.1341 20.9837 29.1878 20.9865 29.241ZM20.979
    25.2368L29.5304 33.7741C29.1338 32.8206 28.4977 31.9911 27.6951
    31.3592C27.2726 31.0267 27.0077 30.5435 26.946 30.0233L20.9928
    24.0798L20.9781 24.0798L20.979 25.2368ZM23.8212 24.0775L26.9807
    27.2318L26.9797 26.0599L24.9931 24.0766L23.8212 24.0775ZM20.9765
    22.0798L26.9764 22.0749L26.9748 20.0749L24.9748 20.0766C24.4225 20.077
    23.9744 19.6297 23.974 19.0774C23.9735 18.5251 24.4209 18.077 24.9732
    18.0766L26.9732 18.0749L26.9715 16.0749L24.9715 16.0766C24.4193 16.077
    23.9712 15.6297 23.9707 15.0774C23.9703 14.5251 24.4176 14.077 24.9699
    14.0766L26.9699 14.0749L26.9683 12.0749L24.9683 12.0766C24.416 12.077
    23.9679 11.6297 23.9674 11.0774C23.967 10.5251 24.4143 10.077 24.9666
    10.0766L26.9666 10.0749L26.9658 9.07494C26.9644 7.41808 25.6202 6.07604
    23.9633 6.0774C22.3065 6.07875 20.9644 7.423 20.9658 9.07985L20.9765
    22.0798Z" fill="#FFFFFF"/>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        color: String,
        size: String
    }
})
</script>
